import { connect } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
var Step1 = function Step1() {
  var submitApplication = function submitApplication() {
    window.open('/public/files/hydrotip-demo.pdf', '_blank');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "ht-step-1"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step1/Step-1.png",
    className: "ht-step-1__1"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step1/Step-1-RO.png",
    className: "ht-step-1__ro1"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step1/step1-Header-link.png",
    className: "ht-step-1__header"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step1/step1-Header-link-RO.png",
    className: "ht-step-1__header-ro",
    onClick: function onClick() {
      return submitApplication();
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step1/step1-Subhead.png",
    className: "ht-step-1__sub-header"
  }));
};
var mdtp = {
  showModalAction: modalActions.show
};
export default connect(null, mdtp)(Step1);